export default `float de( in vec3 pos ) {
  
  float Distance = 1.1428;
  
  float Scale = 0.3868138;
  float r = length( pos ) - 1.0;
  float e = 1.0;
  float oScale = 1.0 / Scale;
  for ( int i = 0; i < 20; i++ ) {
    vec3 v;
    if ( abs( pos.x ) > abs( pos.y ) ) {
      if ( abs( pos.x ) > abs( pos.z ) ) {
        v = vec3( 1.0, 0.0, 0.0 );
      } else {
        v = vec3( 0.0, 0.0, 1.0 );
      }
    } else {
      if ( abs( pos.y ) > abs( pos.z ) ) {
        v = vec3( 0.0, 1.0, 0.0 );
      } else {
        v = vec3( 0.0, 0.0, 1.0 );
      }
    }
    pos = abs( abs( pos ) - Distance * v );
    pos *= oScale;
    e *= Scale;
    r = min( r, e * ( length( pos ) - 1.0 ) );
  }
  return r;
}`